import {Button, message, Modal} from "antd";
import HeaderImage from "../../assets/images/main_header.jpg";

import "./HomeHeader.css";
import NavigationBar from "../NavigationBar/NavigationBar";
import {useState} from "react";
import RequestModal from "../RequestModal/RequestModal";

const HomeHeader = () => {

    const [messageApi, contextHolder] = message.useMessage();

    const [requestModalVisible, setRequestModalVisible] = useState(false);

    const showAlert = (type, content) => {
        messageApi.open({
            type: type,
            content: content,
        });
    };

    return (
        <div className="home-header-container">
            {contextHolder}
            <img src={HeaderImage} alt="Header Background" style={{ width: "100%" }} />
            <div className="navbar-overlay">
                <NavigationBar />
            </div>
            <div className="centered-container">
                <h4> МЕЛОВОЙ ЗАВОД </h4>
                <h1> «БРЯНСКИЙ МЕЛ»</h1>
                <div className="centered-container-description">
                    <p>
                        Проект по освоению месторождения мела "Мирское", который реализует ООО "АгроТрейд" в Погарском
                        районе на юго-западе Брянской области
                    </p>
                </div>
                <Button
                    className="centered-container-button"
                    onClick={() => setRequestModalVisible(true)}
                >
                    Оставить заявку
                </Button>
            </div>


            <Modal
                title={<h3 style={{margin: "0"}}>Оставить заявку</h3>}
                className={"hh-request-modal"}
                open={requestModalVisible}
                onCancel={() => setRequestModalVisible(false)}
                footer={null}
            >
                <RequestModal
                    close={() => setRequestModalVisible(false)}
                    alert={showAlert}
                />
            </Modal>


        </div>
    );
};

export default HomeHeader;